import { shitoRyuPillars } from '../data/content';
import useReveal from '../hooks/useReveal';
import './ShitoRyu.css';

export default function ShitoRyu() {
  const textRef = useReveal();
  const pillarsRef = useReveal();

  return (
    <section id="shitoryu" className="shitoryu">
      <div className="shitoryu__kanji-bg">糸東流</div>
      <div className="shitoryu__inner">
        <div className="shitoryu__grid">
          <div ref={textRef} className="reveal">
            <div className="shitoryu__eyebrow">
              <span className="shitoryu__rule" />
              <span>El Estilo</span>
            </div>
            <h2 className="shitoryu__title">
              SHITO <span className="text-red">RYU</span>
            </h2>
            <div className="shitoryu__jp">糸東流</div>
            <p className="shitoryu__text">
              Fundado por el maestro <strong>Kenwa Mabuni</strong> en 1934, el
              Shito Ryu es uno de los cuatro grandes estilos del Karate Do.
              Une la potencia de Shuri-te con la fluidez de Naha-te.
            </p>
            <p className="shitoryu__text shitoryu__text--last">
              Es el estilo con mayor número de katas del karate tradicional:
              precisión, equilibrio y un profundo respeto por la forma.
            </p>
          </div>

          <div ref={pillarsRef} className="shitoryu__pillars reveal">
            {shitoRyuPillars.map((pillar) => (
              <div key={pillar.title} className="shitoryu__pillar">
                <span className="shitoryu__pillar-kanji">{pillar.kanji}</span>
                <div>
                  <div className="shitoryu__pillar-title">{pillar.title}</div>
                  <p className="shitoryu__pillar-text">{pillar.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}